if(window.innerWidth > 767) {
    document.addEventListener("DOMContentLoaded", function () {

        const navbarLangTrigger = document.querySelector('.js-navbar-lang');
        const navbarLangTarget = document.querySelector('.navbar__lang');

        /**
         * On click
         */

        if (navbarLangTrigger) {
            navbarLangTrigger.addEventListener('click', () => {
                navbarLangToggle();
            });
        }

        /**
         * Navbar lang toggle
         */

        const navbarLangToggle = () => {
            if (navbarLangTarget.classList.contains('navbar__lang--open')) {
                navbarLangTarget.classList.remove('navbar__lang--open');
            } else {
                navbarLangTarget.classList.add('navbar__lang--open');
            }
        }

    });
}